import { connect } from 'react-redux';

import Dropdown from './Dropdown';
import {
    trackRefineSearchClickProcedureDropdown,
    trackRefineSearchSelectProcedure,
} from '../../../../../actions';

const mapDispatchToProps = {
    trackRefineSearchClickProcedureDropdown,
    trackRefineSearchSelectProcedure,
};

export default connect(undefined, mapDispatchToProps)(Dropdown);
